import messages from './member.json' with { type: 'json' };

export const memberFi: Readonly<typeof messages> = messages;
